<br />
<b>Works of the day:</b>
<table class="machine-details-table">
  <thead>
    <th class="daily-item-head">Date</th>
    <th class="daily-item-head">Time</th>
    <th class="daily-item-head">Work</th>
  </thead>
  <tbody *ngIf="machineDailyWorks.length === 0">
    <tr>
      <td><span class="daily-item">-</span></td>
      <td><span class="daily-item">-</span></td>
      <td><span class="daily-item">-</span></td>
    </tr>
  </tbody>
  <tbody *ngIf="machineDailyWorks.length">
    <tr *ngFor="let dailyWork of machineDailyWorks">
      <td>
        <span class="daily-item"> {{ dailyWork.date }}</span>
      </td>
      <td>
        <span class="daily-item"> {{ dailyWork.time }}</span>
      </td>
      <td>
        <span class="daily-item"> {{ dailyWork.job }}</span>
      </td>
    </tr>
  </tbody>
</table>
